import { RequestHeaderConfiguration } from '../types/ApiClientConfig';
import { SharedRequestConfiguration, VehicleParameterUnion } from '../types/GeneralParameter';

export interface ModeSpecificFetchClient {
  getInflateIdLength(): number;
  setRequiredParameters(params: VehicleParameterUnion, configuration: SharedRequestConfiguration): void;
  checkAllRequiredParametersPresent(): boolean;
}

export class GenericFetchClient {
  private configuration: RequestHeaderConfiguration;
  private pathSegment: string | null = null;
  private queryParameter: URLSearchParams | null = null;
  private headerParameters: Record<string, string> = {};

  constructor(configuration: RequestHeaderConfiguration) {
    this.configuration = configuration;
  }

  setPathSegment(path: string) {
    this.pathSegment = path;
  }

  setQueryParameters(parameters: Record<string, string>) {
    const filteredParameters = Object.fromEntries(
      Object.entries(parameters).filter(([_, value]) => value !== undefined && value !== null && value !== ''),
    );

    this.queryParameter = new URLSearchParams(filteredParameters);
  }

  setHeaderParameters(parameters: Record<string, string>) {
    this.headerParameters = parameters;
  }

  private formRequestUrl(): URL {
    if (!this.pathSegment) {
      throw new Error('Path segment is not set');
    }

    const url = new URL(this.configuration.basePath);
    url.pathname = `${url.pathname}${this.pathSegment}`;

    if (this.queryParameter) {
      url.search = this.queryParameter.toString();
    }

    return url;
  }

  async fetchTypedBody<T>(): Promise<T> {
    const requestUrl = this.formRequestUrl();

    const headers = {
      ...this.headerParameters,
      ...(this.configuration.apiKey ? { 'x-api-key': this.configuration.apiKey } : {}),
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    const response = await fetch(requestUrl.toString(), {
      headers,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return (await response.json()) as T;
  }
}
